import { NgModule } from '@angular/core';
import { AmdScrollService } from './scroll.service';
var AmdScrollModule = /** @class */ (function () {
    function AmdScrollModule() {
    }
    AmdScrollModule.decorators = [
        { type: NgModule, args: [{
                    providers: [AmdScrollService]
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdScrollModule.ctorParameters = function () { return []; };
    return AmdScrollModule;
}());
export { AmdScrollModule };
function AmdScrollModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdScrollModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdScrollModule.ctorParameters;
}
//# sourceMappingURL=scroll.module.js.map
//# sourceMappingURL=scroll.module.js.map
